import { useTranslation } from 'react-i18next';
import { fetchTenantAvailableFloors } from 'src/api/lib/tenant';
import { tenantAvailableFloorsQueryKeys } from 'src/api/query-keys/tenant/tenant-available-floors';
import { FilterPopover } from 'src/components/molecules/filter-popover';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useMeilisearch } from 'src/hooks/meilisearch/use-meilisearch';
import { buildFiltersArrayFromFiltersObject } from 'src/hooks/meilisearch/utils/build-filters-array-from-filters-object';
import { buildFiltersObjectFromFiltersArray } from 'src/hooks/meilisearch/utils/build-filters-object-from-filters-array';
import { useUserStore } from 'src/store/user-store';
import { FilterGroup } from 'src/types/interfaces/filter-group';

interface Props {
  filters: SearchState['filter'];
  onChange: (filters: SearchState['filter']) => void;
}

export const SpaceFloorFilterPopover = ({ filters, onChange }: Props) => {
  const { directoryToken } = useUserStore();

  const { results } = useMeilisearch({
    fetch: fetchTenantAvailableFloors,
    queryKey: tenantAvailableFloorsQueryKeys.list(directoryToken ?? ''),
    page: 1,
    perPage: 1000,
  });

  const { t } = useTranslation(['spaceGroups', 'spaces']);

  const filterGroup: FilterGroup<string> = {
    id: 1,
    type: 'floor',
    label: t('spaceGroups:common.createGroupDialog.floor'),
    singleOption: false,
    items:
      results?.hits?.[0]?.floors.map(floor => ({
        label: floor.toString(),
        value: floor.toString(),
      })) ?? [],
  };

  const filtersObject = buildFiltersObjectFromFiltersArray(
    filters as string[][],
  );

  return (
    <FilterPopover
      title={filterGroup.label}
      selected={filtersObject[filterGroup.type] ?? []}
      onChange={option => {
        const filtersArray = buildFiltersArrayFromFiltersObject(
          filterGroup.type,
          option,
          filters,
        );

        onChange(filtersArray);
      }}
      options={filterGroup.items.map(item => ({
        label: item.label,
        value: item.value,
      }))}
    />
  );
};
